import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getQuickeasy2 } from '../../Apis/content';

export const QuickEasy2 = createAsyncThunk('quickeasy2', async (formData, { rejectWithValue }) => {
    try {
        const response = await getQuickeasy2(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const quickeasy2Slice = createSlice({
    name: 'quickeasy2',
    initialState: {
        error: null,
        success: false,
        data: [],
        Single: [],
        tags: [],
        addOn: []
    },
    reducers: {
        clearQuickeasy2Status: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(QuickEasy2.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(QuickEasy2.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(QuickEasy2.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearQuickeasy2Status } = quickeasy2Slice.actions;
export default quickeasy2Slice.reducer;

